"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IntakeActionType = exports.ImportInsuranceMedicamentStatus = exports.CheckMedicamentCode = exports.EmediplanImportResult = exports.MedicineSorting = exports.MedicationUnitType = exports.IntakeMedicamentAdministrationForm = exports.MedicationSourceType = exports.MedicamentStatus = exports.IntakeWithMealEnum = void 0;
var IntakeWithMealEnum;
(function (IntakeWithMealEnum) {
    IntakeWithMealEnum["Before"] = "BEFORE";
    IntakeWithMealEnum["SameTime"] = "SAMETIME";
    IntakeWithMealEnum["After"] = "AFTER";
})(IntakeWithMealEnum || (exports.IntakeWithMealEnum = IntakeWithMealEnum = {}));
var MedicamentStatus;
(function (MedicamentStatus) {
    MedicamentStatus[MedicamentStatus["intake"] = 0] = "intake";
    MedicamentStatus[MedicamentStatus["noIntake"] = 1] = "noIntake";
    MedicamentStatus[MedicamentStatus["hidden"] = 2] = "hidden";
    MedicamentStatus[MedicamentStatus["new"] = 3] = "new";
    MedicamentStatus[MedicamentStatus["dropped"] = 4] = "dropped";
})(MedicamentStatus || (exports.MedicamentStatus = MedicamentStatus = {}));
var MedicationSourceType;
(function (MedicationSourceType) {
    MedicationSourceType["own"] = "own";
    MedicationSourceType["kpt"] = "kpt";
    MedicationSourceType["prescription"] = "rx-portal";
    MedicationSourceType["emediplan"] = "emediplan";
    MedicationSourceType["visana"] = "visana";
    MedicationSourceType["helsana"] = "helsana";
    MedicationSourceType["okk"] = "okk";
    MedicationSourceType["swica"] = "swica";
    MedicationSourceType["atupri"] = "atupri";
})(MedicationSourceType || (exports.MedicationSourceType = MedicationSourceType = {}));
var IntakeMedicamentAdministrationForm;
(function (IntakeMedicamentAdministrationForm) {
    IntakeMedicamentAdministrationForm["SelfIntake"] = "SELFINTAKE";
    IntakeMedicamentAdministrationForm["Administered"] = "ADMINISTERED";
})(IntakeMedicamentAdministrationForm || (exports.IntakeMedicamentAdministrationForm = IntakeMedicamentAdministrationForm = {}));
var MedicationUnitType;
(function (MedicationUnitType) {
    MedicationUnitType["application"] = "application";
    MedicationUnitType["bag"] = "bag";
    MedicationUnitType["tableSpoon"] = "tableSpoon";
    MedicationUnitType["bottle"] = "bottle";
    MedicationUnitType["glas"] = "glas";
    MedicationUnitType["injection"] = "injection";
    MedicationUnitType["cup"] = "cup";
    MedicationUnitType["ms"] = "ms";
    MedicationUnitType["mg"] = "mg";
    MedicationUnitType["ml"] = "ml";
    MedicationUnitType["spray"] = "spray";
    MedicationUnitType["piece"] = "piece";
    MedicationUnitType["pill"] = "pill";
    MedicationUnitType["teeSpoon"] = "teeSpoon";
    MedicationUnitType["drop"] = "drop";
    MedicationUnitType["suppositorie"] = "suppositorie";
})(MedicationUnitType || (exports.MedicationUnitType = MedicationUnitType = {}));
var MedicineSorting;
(function (MedicineSorting) {
    MedicineSorting["createdAsc"] = "created-asc";
    MedicineSorting["createdDesc"] = "created-desc";
    MedicineSorting["titleAsc"] = "title-asc";
    MedicineSorting["titleDesc"] = "title-desc";
})(MedicineSorting || (exports.MedicineSorting = MedicineSorting = {}));
var EmediplanImportResult;
(function (EmediplanImportResult) {
    EmediplanImportResult["error"] = "error";
    EmediplanImportResult["success"] = "success";
    EmediplanImportResult["medicationsFound"] = "medicationsFound";
    EmediplanImportResult["notFullyImported"] = "notFullyImported";
})(EmediplanImportResult || (exports.EmediplanImportResult = EmediplanImportResult = {}));
var CheckMedicamentCode;
(function (CheckMedicamentCode) {
    CheckMedicamentCode["alreadyExists"] = "ALREADY_EXISTS";
    CheckMedicamentCode["genericExists"] = "GENERIC_EXISTS";
    CheckMedicamentCode["originalExists"] = "ORIGINAL_EXISTS";
})(CheckMedicamentCode || (exports.CheckMedicamentCode = CheckMedicamentCode = {}));
var ImportInsuranceMedicamentStatus;
(function (ImportInsuranceMedicamentStatus) {
    ImportInsuranceMedicamentStatus["imported"] = "IMPORTED";
    ImportInsuranceMedicamentStatus["noInsurance"] = "NO_INSURANCE";
    ImportInsuranceMedicamentStatus["consentRevoked"] = "CONSENT_REVOKED";
})(ImportInsuranceMedicamentStatus || (exports.ImportInsuranceMedicamentStatus = ImportInsuranceMedicamentStatus = {}));
var IntakeActionType;
(function (IntakeActionType) {
    IntakeActionType["take"] = "take";
    IntakeActionType["skip"] = "skip";
    IntakeActionType["reset"] = "reset";
    IntakeActionType["discontinue"] = "discontinue";
})(IntakeActionType || (exports.IntakeActionType = IntakeActionType = {}));
//# sourceMappingURL=medicationPlan.js.map